<div class="tenders-container">
  <div class="tenders-header border-bottom px-4 py-4 mb-4">
    <div class="container d-flex flex-wrap align-items-center justify-content-between gap-2">
      <h5 class="mb-0 fw-bold" style="font-size: 1.25rem; color: var(--heading-color);">Tenders</h5>
      <div class="d-none d-lg-flex align-items-center gap-3" *ngIf="canImportContracts">
        <ul class="nav nav-links">
          <li class="nav-item">
            <a class="nav-link pe-lg-0 text-muted small fw-bold" href="javascript:void(0);"
              (click)="openContractImporterModal()">
              <i class="fas fa-file-excel me-2 text-success"></i> Excel Contract Importer
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <div class="container">



    <div class="tenders-card shadow-sm mb-5">
      <div class="jft-search-wrapper px-4 border-bottom">
        <jft-tender-search-bar [company]="company" (onChanges)="search($event)"></jft-tender-search-bar>
      </div>

      <div class="table-responsive">
        <table class="table tenders-table mb-0">
          <thead>
            <tr>
              <th>
                <a class="pointer d-flex align-items-center" (click)="sort($event, 'name')">
                  Name <i *ngIf="order_field === 'name' && order" class="fa ms-2"
                    [ngClass]="{'fa-chevron-up': order === 'ASC', 'fa-chevron-down': order === 'DESC'}"></i>
                </a>
              </th>
              <th class="text-center">
                <a class="pointer d-flex align-items-center justify-content-center"
                  (click)="sort($event, 'contracts_total')">
                  Locations <i *ngIf="order_field === 'contracts_total' && order" class="fa ms-2"
                    [ngClass]="{'fa-chevron-up': order === 'ASC', 'fa-chevron-down': order === 'DESC'}"></i>
                </a>
              </th>
              <th class="text-center">
                <a class="pointer d-flex align-items-center justify-content-center"
                  (click)="sort($event, 'suppliers_total')">
                  Suppliers <i *ngIf="order_field === 'suppliers_total' && order" class="fa ms-2"
                    [ngClass]="{'fa-chevron-up': order === 'ASC', 'fa-chevron-down': order === 'DESC'}"></i>
                </a>
              </th>
              <th class="text-center">
                <a class="pointer d-flex align-items-center justify-content-center"
                  (click)="sort($event, 'bids_submitted_total')">
                  Bids <i *ngIf="order_field === 'bids_submitted_total' && order" class="fa ms-2"
                    [ngClass]="{'fa-chevron-up': order === 'ASC', 'fa-chevron-down': order === 'DESC'}"></i>
                </a>
              </th>
              <th class="text-center">
                <a class="pointer d-flex align-items-center justify-content-center"
                  (click)="sort($event, 'current_round')">
                  Round <i *ngIf="order_field === 'current_round' && order" class="fa ms-2"
                    [ngClass]="{'fa-chevron-up': order === 'ASC', 'fa-chevron-down': order === 'DESC'}"></i>
                </a>
              </th>
              <th class="text-center">
                <a class="pointer d-flex align-items-center justify-content-center"
                  (click)="sort($event, 'date_round_end')">
                  Round Time <i *ngIf="order_field === 'date_round_end' && order" class="fa ms-2"
                    [ngClass]="{'fa-chevron-up': order === 'ASC', 'fa-chevron-down': order === 'DESC'}"></i>
                </a>
              </th>
              <th class="text-center">
                <a class="pointer d-flex align-items-center justify-content-center"
                  (click)="sort($event, 'current_round_status')">
                  Round Status <i *ngIf="order_field === 'current_round_status' && order" class="fa ms-2"
                    [ngClass]="{'fa-chevron-up': order === 'ASC', 'fa-chevron-down': order === 'DESC'}"></i>
                </a>
              </th>
              <th class="text-center">
                <a class="pointer d-flex align-items-center justify-content-center" (click)="sort($event, 'status')">
                  Tender Status <i *ngIf="order_field === 'status' && order" class="fa ms-2"
                    [ngClass]="{'fa-chevron-up': order === 'ASC', 'fa-chevron-down': order === 'DESC'}"></i>
                </a>
              </th>
            </tr>
          </thead>
          <router-outlet></router-outlet>
        </table>
      </div>
    </div>
  </div>
</div>